export const isCompleteReviewer = (r)=>Boolean(r.firstName && r.lastName && r.email);
export const allReviewersComplete = (reviewers)=>reviewers.every(isCompleteReviewer);
